import { Injectable } from '@angular/core';


@Injectable()

export class Globals {    
    upsiAdmin :boolean = JSON.parse(localStorage.getItem("resources")).some(function(o){return o["Menu"] === "UPSI Detail All";}) 

}